<template>
  <div>
    <div class="row">
      <div class="col-6">
        <b>Manage logo for:</b> {{ site.name }}
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <form enctype="multipart/form-data">
          <br>
          <div class="form-group">
            <div class="input-group mb-3">
              <div class="custom-file">
                <input type="file" class="custom-file-input" accept=".png" @change="processFile($event)">
                <label class="custom-file-label">{{ logo.file_name }}</label>
              </div>
            </div>
          </div>
          <small class="form-text text-muted">Only .png's are accepted. 100x100 recommended.</small>
          <button type="button" class="btn btn-hub-primary" @click="uploadSiteLogo()">Upload</button>
          <router-link :to="{ name: 'AdminSiteIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'site_id'
  ],
  data: function () {
    return {
      logo: {
        site_id: 0,
        file_name: '',
        file: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      site: 'singleSite'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getSite', this.site_id)
  },
  methods: {
    processFile (event) {
      this.logo.file = event.target.files[0]
      this.logo.file_name = event.target.files[0].name
    },
    uploadSiteLogo () {
      if (this.logo.file !== '') {
        this.logo.site_id = this.site_id
        this.$store.dispatch('uploadSiteLogo', this.logo)
      } else {
        alert('Please select a file for the import.')
      }
    }
  }
}
</script>
